/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryDataPoints } from './HistoryDataPoints';
import {
    HistoryDataPointsFromJSON,
    HistoryDataPointsFromJSONTyped,
    HistoryDataPointsToJSON,
    HistoryDataPointsToJSONTyped,
} from './HistoryDataPoints';

/**
 * 
 * @export
 * @interface GetHistoryRangeSystem200ResponseInner
 */
export interface GetHistoryRangeSystem200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetHistoryRangeSystem200ResponseInner
     */
    deviceId?: string;
    /**
     * 
     * @type {HistoryDataPoints}
     * @memberof GetHistoryRangeSystem200ResponseInner
     */
    history?: HistoryDataPoints;
}

/**
 * Check if a given object implements the GetHistoryRangeSystem200ResponseInner interface.
 */
export function instanceOfGetHistoryRangeSystem200ResponseInner(value: object): value is GetHistoryRangeSystem200ResponseInner {
    return true;
}

export function GetHistoryRangeSystem200ResponseInnerFromJSON(json: any): GetHistoryRangeSystem200ResponseInner {
    return GetHistoryRangeSystem200ResponseInnerFromJSONTyped(json, false);
}

export function GetHistoryRangeSystem200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHistoryRangeSystem200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'history': json['history'] == null ? undefined : HistoryDataPointsFromJSON(json['history']),
    };
}

export function GetHistoryRangeSystem200ResponseInnerToJSON(json: any): GetHistoryRangeSystem200ResponseInner {
    return GetHistoryRangeSystem200ResponseInnerToJSONTyped(json, false);
}

export function GetHistoryRangeSystem200ResponseInnerToJSONTyped(value?: GetHistoryRangeSystem200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deviceId': value['deviceId'],
        'history': HistoryDataPointsToJSON(value['history']),
    };
}

